__turbopack_context__.v({
  "backButton": "qW7dDW_backButton",
  "body": "qW7dDW_body",
  "button": "qW7dDW_button",
  "classCard": "qW7dDW_classCard",
  "closeButton": "qW7dDW_closeButton",
  "closeButtonIcon": "qW7dDW_closeButtonIcon",
  "footer": "qW7dDW_footer",
  "footerRight": "qW7dDW_footerRight",
  "header": "qW7dDW_header",
  "iconBack": "qW7dDW_iconBack",
  "list": "qW7dDW_list",
  "notFoundWord": "qW7dDW_notFoundWord",
  "notFoundWordsList": "qW7dDW_notFoundWordsList",
  "popup": "qW7dDW_popup",
  "popupContainer": "qW7dDW_popupContainer",
  "resultText": "qW7dDW_resultText",
  "title": "qW7dDW_title",
});
